// Zentrale Farb-Konstanten (Stille Buchkultur).
// Werte deckungsgleich mit tailwind.config.js — fuer Inline-Styles,
// wo Tailwind-Klassen nicht greifen (z.B. Mitarbeiter-Farb-Dot).

export const C = {
  teal: '#1D6B6B',
  tealDark: '#155050',
  tealLight: '#D6E7E6',
  tealSoft: '#E1F5EE',
  grund: '#F4EFE4',
  kopf: '#E9E1CF',
  feldrand: '#948C7C',
  cream: '#FDFBF7',
  creamWarm: '#F9F5EA',
  creamDark: '#F4EEE3',
  gold: '#B8A07A',
  goldDark: '#6F6236',
  goldSoft: '#F2EBD9',
  ink: '#2B2B2B',
  inkSoft: '#4A4743',
  inkFaint: '#65615C',
  line: '#D3CAB6',
  coral: '#993C1D',
  coralSoft: '#F5C4B3'
} as const;

// ---------------------------------------------------------------------
// RUECKFALLFARBEN (A14.3)
//
// Zustaende und Mitarbeiter tragen ihre Farbe in der Datenbank. Wer
// keine hat, bekommt ein neutrales Grau — und genau dieses Grau stand
// sechsmal als Hexwert im Quelltext, an drei Stellen `#5A5854` und an
// drei weiteren `#8C8985`. Zwei verschiedene Graus fuer dieselbe Sache,
// weil niemand sehen konnte, was die andere Stelle nimmt.
//
// Als benannte Konstante und nicht als blosser Verweis auf `C`: der Name
// sagt, WOFUER das Grau steht. `C.inkSoft` sagt nur, welches es ist —
// und die naechste Aufrufstelle nimmt dann wieder irgendeines.
// ---------------------------------------------------------------------

/** Ein Zustand ohne gepflegte Farbe. */
export const FARBE_ZUSTAND_FALLBACK = C.inkSoft;

/** Ein Mitarbeiter ohne gepflegte Farbe. */
export const FARBE_NUTZER_FALLBACK = C.inkFaint;

// ---------------------------------------------------------------------
// FLÄCHEN, AUF DENEN TEXT STEHT (E58, seit E61 hier)
//
// Gegen diese vier misst kontrastWaechter.test.ts jede Textfarbe, und
// gegen dieselben vier dunkelt lib/zustandFarbe.ts eine zu helle
// Zustandsfarbe ab. Die Liste steht EINMAL — stünde sie im Test und in
// der Laufzeit je für sich, prüfte der Wächter irgendwann gegen andere
// Flächen als die, für die die Oberfläche rechnet.
// ---------------------------------------------------------------------
export const TEXT_FLAECHEN = {
  cream: C.cream,
  grund: C.grund,
  zebra: C.creamDark,
  kopf: C.kopf
} as const;

/** Die Schranke für Text (WCAG 1.4.3). */
export const TEXT_KONTRAST_MIN = 4.5;
